/*!
 * Serialize all form data into a query string
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}   form The form to serialize
 * @return {String}      The serialized form data
 */
export function serialize(form: HTMLFormElement): string {
  // Setup our serialized data
  const serialized = [];

  // Loop through each field in the form
  for (const field of form.elements as any) {
    // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
    if (
      !field.name ||
      field.disabled ||
      field.type === "file" ||
      field.type === "reset" ||
      field.type === "submit" ||
      field.type === "button"
    ) {
      continue;
    }

    // If a multi-select, get all selections
    if (field.type === "select-multiple") {
      for (const option of field.options) {
        if (!option.selected) {
          continue;
        }

        serialized.push(
          encodeURIComponent(field.name) +
            "=" +
            encodeURIComponent(option.value),
        );
      }
    }

    // Convert field data to a query string
    else if (
      (field.type !== "checkbox" && field.type !== "radio") ||
      field.checked
    ) {
      serialized.push(
        encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value),
      );
    }
  }
  return serialized.join("&");
}
